import { Injectable, OnDestroy } from '@angular/core';
import { assert } from '@sama/js-core';
import { environment } from '../../../environments/environment';
import { BaseSaveManagerService } from './base-save-manager.service';
import { ExecutionQueueService } from './execution-queue.service';

@Injectable()
export class PeriodicSaveManagerService implements OnDestroy {
  /**
   * If you use, make sure you put it on executionQueue to prevent race
   * conditions.
   */
  private save!: () => Promise<void> | void;
  private saveDelay!: number;
  private currentTimeout?: number;

  constructor(
    private baseSaveManager: BaseSaveManagerService,
    private executionQueue: ExecutionQueueService,
  ) {}

  /**
   * @param saveFunction should return a promise to show the save indicator,
   * otherwise return `undefined`.
   */
  initialize(saveFunction: () => Promise<void> | void) {
    assert(!this.save, 'this should only be used once per page');

    this.save = saveFunction;
    this.saveDelay = environment.draftSavePeriod;

    this.start();
  }

  start() {
    if (this.currentTimeout) {
      throw new Error(
        'Start was attempted while existing timer still running!',
      );
    }

    this.currentTimeout = window.setTimeout(() => {
      void this.executionQueue.enqueue(() =>
        this.baseSaveManager.withSaveIndicator(this.save).then(() => {
          this.currentTimeout = undefined;
          this.start();
        }),
      );
    }, this.saveDelay);
  }

  stop() {
    clearTimeout(this.currentTimeout);
    this.currentTimeout = undefined;
  }

  ngOnDestroy() {
    this.stop();
  }
}
